import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-skeleton-loading',
  imports: [],
  templateUrl: './skeleton-loading.component.html',
  standalone: true,
})
export class SkeletonLoadingComponent {
  @Input() showLoadingText = true;
  @Input() loadingText = 'Lade Daten...';
  @Input() showTabs = true;
  @Input() numberOfTabs = 4;
  @Input() numberOfCards = 6;
  @Input() containerClass = 'bg-gray-100 p-6 rounded-lg';
  @Input() gridClass = 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2';

  createArray(length: number): number[] {
    return Array.from({ length }, (_, i) => i);
  }
}
